import { render, staticRenderFns } from "./DocumentCreate.vue?vue&type=template&id=6861f42c&scoped=true"
import script from "./DocumentCreate.vue?vue&type=script&lang=js"
export * from "./DocumentCreate.vue?vue&type=script&lang=js"
import style0 from "./DocumentCreate.vue?vue&type=style&index=0&id=6861f42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861f42c",
  null
  
)

export default component.exports